import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp8};
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border-radius: 2px;
  position: relative;
  margin-top: 10px;

  &:after {
    content: '';
    position: absolute;
    top: -20px;
    left: calc(50% - 10px);
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent ${props => props.backgroundColor} transparent;
  }
`
